import {
  Component,
  Input,
  AfterContentChecked,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";

@Component({
  selector: "text-trimmer-popover",
  template: `<div style="display:none;" #contentWrapper>
      <ng-content></ng-content>
    </div>
    <span
      *ngIf="trimText(textElement, maxLength) !== textElement"
      [tooltip]="textElement"
      placement="top"
    >
      {{ trimText(textElement, maxLength) }}
    </span>
    <span *ngIf="trimText(textElement, maxLength) === textElement">
      {{ trimText(textElement, maxLength) }}
    </span> `,
})
export class TextTrimPopoverComponent {
  @Input() public maxLength: number;
  @Input("text")
  public textElement: string = "";
  @Input("breakWord") public breakWord: boolean = false;

  @ViewChild("contentWrapper")
  public contentWrapper: ElementRef;

  constructor() {}

  public trimText(text: string, maxlength = 14) {
    if (!text) {
      return "";
    }
    if (this.breakWord) {
      return text.length > maxlength ? text.slice(0, maxlength) + "..." : text;
    }
    return trimTextByWord(text, maxlength);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/text-trim-popover/text-trim-popover.component.ts